


































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Picture, Typography } from '@/components/atoms';

@Component({ components: { Picture, Typography } })
export default class MarketingCenterMockup extends Vue {
  @Prop(Number) readonly width?: number;
  @Prop(Number) readonly height?: number;
  @Prop(String) readonly icon?: string;
  @Prop(String) readonly name?: string;
  @Prop(Boolean) readonly selected?: boolean;
}
